export default __webpack_public_path__ + "static/media/snapchatlogo.bbdb37c9.png";